import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const ManageListingContainerAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "manage-listing-container" */ './manage-listing-container'),
  componentName: 'ManageListingContainer',
});
